import React from 'react';
import { branch, renderComponent } from 'recompose';
import { Spinner } from '@blueprintjs/core';

export const withSpinner = (checkFn) => branch(
  checkFn,
  renderComponent(props => (
    <div className="container" style={{ textAlign: 'center' }}>
      <Spinner />
    </div>
  ))
);



// WEBPACK FOOTER //
// ./src/utils/hocs.js